/**
 * เปิดหน้าต่างเลือก/ถ่ายรูปหลักฐานการจัดส่งที่มี drop zone + พรีวิวรูป
 * @param {import('sweetalert2').default} swal - instance ของ SweetAlert2 (this.$swal)
 * @returns {Promise<File|null>} ไฟล์รูปที่เลือก หรือ null ถ้ายกเลิก
 */
export async function openProofUploadDialog(swal) {
  let selectedFile = null;

  const html = `
    <div style="font-family:'Sarabun','Noto Sans Thai',sans-serif;text-align:left;">
      <input id="dp-file" type="file" accept="image/*" capture="environment" style="display:none" />

      <div id="dp-drop" style="
        border:2px dashed #F4811F;border-radius:16px;padding:30px 16px;text-align:center;
        cursor:pointer;background:#FFF7ED;transition:background .18s,border-color .18s;">
        <div style="
          width:56px;height:56px;margin:0 auto 10px;border-radius:50%;
          background:linear-gradient(135deg,#F4811F 0%,#E56A0A 100%);
          display:flex;align-items:center;justify-content:center;
          box-shadow:0 6px 16px rgba(244,129,31,0.35);">
          <span style="font-size:26px;line-height:1;">📷</span>
        </div>
        <div style="font-weight:800;color:#9A3412;font-size:15px;">แตะเพื่อเลือกรูป หรือถ่ายภาพ</div>
        <div style="font-size:12px;color:#C2660A;margin-top:4px;">รองรับ JPG, PNG, WEBP</div>
      </div>

      <div id="dp-preview-wrap" style="display:none;">
        <img id="dp-preview" alt="พรีวิวรูปหลักฐาน" style="
          width:100%;border-radius:16px;max-height:300px;object-fit:contain;
          background:#F3F4F6;border:1px solid #E5E7EB;" />
        <button id="dp-change" type="button" style="
          margin-top:10px;width:100%;padding:9px;border-radius:12px;border:1px solid #E5E7EB;
          background:#fff;color:#374151;font-weight:700;cursor:pointer;">
          🔄 เปลี่ยนรูป
        </button>
      </div>
    </div>
  `;

  const result = await swal.fire({
    title: 'แนบรูปหลักฐานการจัดส่ง',
    html,
    width: 440,
    showCancelButton: true,
    confirmButtonText: 'อัปโหลด',
    cancelButtonText: 'ยกเลิก',
    reverseButtons: true,
    focusConfirm: false,
    customClass: {
      confirmButton: 'dp-swal-confirm',
      cancelButton: 'dp-swal-cancel',
    },
    didOpen: () => {
      const fileInput = document.getElementById('dp-file');
      const drop = document.getElementById('dp-drop');
      const previewWrap = document.getElementById('dp-preview-wrap');
      const preview = document.getElementById('dp-preview');
      const changeBtn = document.getElementById('dp-change');

      const showPreview = (file) => {
        selectedFile = file;
        preview.src = URL.createObjectURL(file);
        drop.style.display = 'none';
        previewWrap.style.display = 'block';
      };

      const openPicker = () => fileInput.click();
      drop.addEventListener('click', openPicker);
      changeBtn.addEventListener('click', openPicker);

      fileInput.addEventListener('change', (e) => {
        const f = e.target.files && e.target.files[0];
        if (f) showPreview(f);
      });

      // drag & drop
      ['dragover', 'dragenter'].forEach((ev) =>
        drop.addEventListener(ev, (e) => {
          e.preventDefault();
          drop.style.background = '#FFEDD5';
          drop.style.borderColor = '#E56A0A';
        })
      );
      ['dragleave', 'drop'].forEach((ev) =>
        drop.addEventListener(ev, (e) => {
          e.preventDefault();
          drop.style.background = '#FFF7ED';
          drop.style.borderColor = '#F4811F';
        })
      );
      drop.addEventListener('drop', (e) => {
        const f = e.dataTransfer.files && e.dataTransfer.files[0];
        if (f) showPreview(f);
      });
    },
    preConfirm: () => {
      if (!selectedFile) {
        swal.showValidationMessage('กรุณาเลือกรูปก่อนกดอัปโหลด');
        return false;
      }
      return selectedFile;
    },
  });

  return result.isConfirmed ? result.value : null;
}
